/* eslint-disable no-lonely-if */
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import { Box, styled } from '@mui/material';

import { useAppContextFeatures } from '../../context/AppContext';

import { routeTypes } from '../../hooks/useSystemRoutes';

import Sidebar from './Sidebar';
import Menu from './Menu';

import { useBrowserConfigs, scopes as browserConfigScopes } from '../../hooks/useBrowserConfigs';
import { useTranslations } from '../../hooks/useTranslations';
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 70; // 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    // paddingTop: APP_BAR_DESKTOP + 24,
    paddingTop: APP_BAR_DESKTOP + 0,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

// ----------------------------------------------------------------------

export default function Frame() {

  const theme = useTheme();

  const { appSettings, toggleSidebarDock, toggleNavOpen, checkCurrentRouteIsMenuHide } = useAppContextFeatures()

  const { t: tSidebar } = useTranslations({ ns: ["sidebar", "layout", "common"] })
  const { t: tMenu } = useTranslations({ ns: ["layout"] })

  const matchesLgView = useMediaQuery(theme.breakpoints.up('lg'));

  const { getConfigs: getBrowserConfigs, updateConfigs: updateBrowserConfigs } = useBrowserConfigs(routeTypes.workstation)

  // const [open, setOpen] = useState(false);
  const open = appSettings?.isNavOpen
  const menuShow = checkCurrentRouteIsMenuHide() === false // if the route is not in menu hide list
  const [navMinimize, setNavMinimize] = useState(Boolean(appSettings?.isSidebarDocked))

  // _browserConfigDisplay
  let _browserConfigDisplay = getBrowserConfigs(browserConfigScopes.display, [])

  // check browser config
  useEffect(() => {

    // only apply to lg view
    if (matchesLgView === true) {
      // check browser configs
      if (_browserConfigDisplay?.sidebarAlwaysHide) {

        let dockStatus = Boolean(_browserConfigDisplay?.sidebarAlwaysHide)
        toggleSidebarDock(dockStatus)

      }
    }

  }, [_browserConfigDisplay?.sidebarAlwaysHide])

  useEffect(() => {

    // only apply to lg view
    if (matchesLgView === true) {
      setNavMinimize(Boolean(appSettings?.isSidebarDocked))
    }

  }, [appSettings?.isSidebarDocked])

  // detect the view is changed
  useEffect(() => {

    if (matchesLgView === false) {
      console.log('matchesLgView', matchesLgView)
      toggleSidebarDock(true)
    }

  }, [matchesLgView])

  const generateMainSx = (theme) => {

    if (menuShow === false) {

      return {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      }
    }

    return {}

  }

  return (
    <>
      {
        menuShow &&
        <Menu
          // onOpenNav={() => setOpen(true)}
          onOpenNav={() => {
            toggleNavOpen()
          }}
          navMinimize={navMinimize}
          t={tMenu}
        />
      }

      <Sidebar
        openNav={open}
        // onCloseNav={() => setOpen(false)}
        onCloseNav={() => {
          toggleNavOpen()
        }}
        showNavMinimizeButton={matchesLgView}
        navMinimize={navMinimize}
        onToggleNavMinimize={() => {

          // need to check the view port is lg onnly allow to proceed
          // console.log('matchesLgView', matchesLgView)

          let navMinOption = true;

          if (matchesLgView) { // view is in LG
            navMinOption = !navMinimize
          }

          // setNavMinimize(navMinOption)

          // console.log('navMinOption', navMinOption)
          toggleSidebarDock(navMinOption)

          // testing
          updateBrowserConfigs(
            browserConfigScopes.display,
            {
              sidebarAlwaysHide: navMinOption,
            }
          )

        }}
        t={tSidebar}
      />

      <Main
        sx={generateMainSx()}
      >
        <Outlet />
      </Main>
    </>
  );
}
